
export default class Topics{
	constructor(){
		if(document.body.classList.contains("topics-article")){
			this.initTopicArticle();
		}
	}
	initTopicArticle(){
		if(window.currentContext == "pc"){
			const headermeta = document.querySelector(".topics__article__header__meta");
			const main = document.querySelector(".topics__article");
			if(headermeta && main){
				ScrollTrigger.create({
					trigger: headermeta,
					start: "top-="+rpx(30)+" top",
					endTrigger: main,
					end: ()=>"bottom+="+(window.innerHeight - headermeta.offsetHeight - rpx(30))+" bottom",
					pin: true,
					pinSpacing: false
				});
			}
		}
	}
}